(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionInfoCustom', ServiceTimeSessionInfoCustom);

    ServiceTimeSessionInfoCustom.$inject = ['$resource'];

    function ServiceTimeSessionInfoCustom($resource) {


        var getServiceTimeSessionInfoByServiceItemId = function (serviceItemId) {
            //
            var resourceUrl = 'api/service-time-session-infos-by-service-item-id?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getServiceTimeSessionInfoByServiceItemId: getServiceTimeSessionInfoByServiceItemId

        };
    }
})();
